import React from 'react'

export default function LoadingIndicator ()
{
  return (
    <div className='loading-indicator'>Loading...</div>
  )
}
